import { FlexibleContent, HeroSlider } from '@/templates';
import { getBaseLayout } from '@/layouts/BaseLayout';

import { getAllRoutes } from '@/lib/graphql/api';
import getInitialProps from '@/lib/graphql/api/getInitialProps';
import {
  FlexibleContentBlocks,
  pagePropsPartial,
  seo,
  sliderHero,
} from '@/lib/graphql/partials';
import { PageQuery } from '@/lib/graphql/querys';
import { pagePropsServerTransformer } from '@/lib/graphql/transformers';
import { config } from '@/config';

import type { NextPageWithLayout } from 'pages/_app';

const Brand: NextPageWithLayout = ({
  page: { hero, flexibleContent },
}: any) => (
  <>
    <HeroSlider hero={hero} />

    <FlexibleContent flexible={flexibleContent?.flexible} type="Page" />
  </>
);

export async function getStaticProps({ params }: any) {
  const Query = PageQuery(
    pagePropsPartial,
    `
      page(id: $slug, idType: URI) {
        ${seo}
        hero:${sliderHero('Page')}
        flexibleContent: ${FlexibleContentBlocks('Page')}
      }
    `,
    '',
  );
  const SLUG = `/promociones/${params.slug}`;

  return await pagePropsServerTransformer({
    staticProps: await getInitialProps(Query, { slug: SLUG }),
    type: 'Page',
    path: SLUG,
  });
}

export async function getStaticPaths() {
  const allProducts = await getAllRoutes({
    type: 'pages',
    queryParams: `where: { parent: ${config.idPagePromotions}, status: PUBLISH }`,
  });

  return {
    paths: process.env.FULL_DEPLOY
      ? allProducts.filter((value) => value !== '/promociones/navidad')
      : allProducts.slice(0, 1),
    fallback: 'blocking',
  };
}

Brand.getLayout = getBaseLayout;

export default Brand;
